import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddUOM = createAsyncThunk(
  "other/AddUOM",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/uom/create/`, data)
    return response.data
  }
); 

export const UpdateUOM = createAsyncThunk(
  "other/UpdateUOM",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/uom/update/${data.id}/`, data)
    return response.data
  }
);

export const DeleteUOM = createAsyncThunk(
  "other/DeleteUOM",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/uom/delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

export const GetUOMs = createAsyncThunk(
  "other/GetUOMs",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/uom/list/`);
    return data
  }
);

